"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TabsProvider = exports.useTabsContext = exports.TabsContext = void 0;
var react_1 = __importStar(require("react"));
var useControllableValue_1 = __importDefault(require("../../helpers/hook/useControllableValue"));
exports.TabsContext = react_1.createContext(undefined);
var useTabsContext = function () {
    var context = react_1.useContext(exports.TabsContext);
    if (!context) {
        throw new Error('useTabsContext must be inside a Tabs');
    }
    return context;
};
exports.useTabsContext = useTabsContext;
var TabsProvider = function (_a) {
    var uid = _a.uid, vertical = _a.vertical, currentIndex = _a.currentIndex, onChanging = _a.onChanging, onChange = _a.onChange, children = _a.children;
    var _b = useControllableValue_1["default"]({
        value: currentIndex || 0,
        onChanging: onChanging,
        onChange: onChange
    }), stateIndex = _b[0], setStateIndex = _b[1];
    return (react_1["default"].createElement(exports.TabsContext.Provider, { value: {
            uid: uid,
            vertical: vertical,
            currentIndex: stateIndex,
            changeIndex: setStateIndex
        } }, children));
};
exports.TabsProvider = TabsProvider;
//# sourceMappingURL=TabsContext.js.map